import { lazy } from 'react';
import { RouteObject } from 'react-router-dom';

const HomePage = lazy(() => import('../pages/home/page'));
const LoginPage = lazy(() => import('../pages/login/page'));
const StoreListPage = lazy(() => import('../pages/store-list/page'));
const StoreDetailPage = lazy(() => import('../pages/store-detail/page'));
const StoreReservationPage = lazy(() => import('../pages/store-reservation/page'));
const PaymentCheckoutPage = lazy(() => import('../pages/payment/checkout'));
const PaymentSuccessPage = lazy(() => import('../pages/payment/success'));
const PaymentFailPage = lazy(() => import('../pages/payment/fail'));
const ReservationCheckPage = lazy(() => import('../pages/reservation-check/page'));
const NotFoundPage = lazy(() => import('../pages/NotFound'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <HomePage />,
  },
  {
    path: '/login',
    element: <LoginPage />,
  },
  {
    path: '/stores',
    element: <StoreListPage />,
  },
  {
    path: '/store/:slug',
    element: <StoreDetailPage />,
  },
  {
    path: '/store/:slug/reservation',
    element: <StoreReservationPage />,
  },
  {
    path: '/payment/checkout',
    element: <PaymentCheckoutPage />,
  },
  {
    path: '/payment/success',
    element: <PaymentSuccessPage />,
  },
  {
    path: '/payment/fail',
    element: <PaymentFailPage />,
  },
  {
    path: '/reservation-check',
    element: <ReservationCheckPage />,
  },
  {
    path: '*',
    element: <NotFoundPage />,
  },
];

export default routes;
